import { render } from "./DashboardInventarios.vue?vue&type=template&id=4c9bbd35"
import script from "./DashboardInventarios.vue?vue&type=script&lang=js"
export * from "./DashboardInventarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__